import { render, staticRenderFns } from "./SeveritySetup.vue?vue&type=template&id=d184c49c&scoped=true&"
import script from "./SeveritySetup.vue?vue&type=script&lang=ts&"
export * from "./SeveritySetup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d184c49c",
  null
  
)

export default component.exports